import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sidemenu-item',
  templateUrl: './sidemenu-item.component.html',
  styleUrls: ['./sidemenu-item.component.scss'],
})
/**
 * Side Menu Item atom
 */
export class SidemenuItemComponent {
  @Input() icon?: string;
  @Input() isMobile = true;
  @Input() isActive = false;
  @Input() itemName = 'Item';
  @Input() expandRow = false;
  @Output() clickAction = new EventEmitter<any>();

  /**
   * Emits click action event for underlying material button
   */
  emitClick() {
    this.clickAction.emit();
  }
}
